export const math = (values, process) => {
  switch(process){
    case "+":
      return values.reduce((prev, curr) => {prev+curr}, 0);
    case "-":
      return values.reduce((prev, curr) =>{prev-curr}, values[0]);
    case "*":
      return values.reduce((prev, curr) =>{prev*curr}, values[0]);
    case "/":
      return values.reduce((prev, curr) =>{prev/curr}, values[0]);
  }
}

const toRadians = (deg) => deg * (Math.PI / 180);

export const sin = (...inputs) => {
  let results;

  if (inputs.length > 4) {
    results = inputs.slice(0, inputs.length - 3).map(x => Math.sin(toRadians(x)));
  }

  if (inputs.length === 4) {
    results = Math.sin(toRadians(inputs[0]));
  }

  return results;
};

export const cos = (...inputs) => {
  let results;

  if (inputs.length > 4) {
    results = inputs.slice(0, inputs.length - 3).map(x => Math.cos(toRadians(x)));
  }

  if (inputs.length === 4) {
    results = Math.cos(toRadians(inputs[0]));
  }

  return results;
};

export const tan = (...inputs) => {
  let results;

  if (inputs.length > 4) {
    results = inputs.slice(0, inputs.length - 3).map(x => Math.tan(toRadians(x)));
  }

  if (inputs.length === 4) {
    results = Math.tan(toRadians(inputs[0]));
  }

  return results;
};

export const asin = (...inputs) => {
  let results;

  if (inputs.length > 4) {
    results = inputs.slice(0, inputs.length - 3).map(x => Math.asin(x));
  }

  if (inputs.length === 4) {
    results = Math.asin(inputs[0]);
  }

  return results;
};

export const acos = (...inputs) => {
  let results;

  if (inputs.length > 4) {
    results = inputs.slice(0, inputs.length - 3).map(x => Math.acos(x));
  }

  if (inputs.length === 4) {
    results = Math.acos(inputs[0]);
  }

  return results;
};

export const atan = (...inputs) => {
  let results;

  if (inputs.length > 4) {
    results = inputs.slice(0, inputs.length - 3).map(x => Math.atan(x));
  }

  if (inputs.length === 4) {
    results = Math.atan(inputs[0]);
  }

  return results;
};

export const sinh = (...inputs) => {
  let results;

  if (inputs.length > 4) {
    results = inputs.slice(0, inputs.length - 3).map(x => Math.sinh(x));
  }

  if (inputs.length === 4) {
    results = Math.sinh(inputs[0]);
  }

  return results;
};

export const cosh = (...inputs) => {
  let results;

  if (inputs.length > 4) {
    results = inputs.slice(0, inputs.length - 3).map(x => Math.cosh(x));
  }

  if (inputs.length === 4) {
    results = Math.cosh(inputs[0]);
  }

  return results;
};

export const tanh = (...inputs) => {
  let results;

  if (inputs.length > 4) {
    results = inputs.slice(0, inputs.length - 3).map(x => Math.tanh(x));
  }

  if (inputs.length === 4) {
    results = Math.tanh(inputs[0]);
  }

  return results;
};


export const add = (...inputs) => {
  let results
  
  if(inputs.length > 4){
    results = inputs.slice(0, inputs.length-3).reduce((prev, curr) => {return prev+curr});
  }
  if(inputs.length == 4){
    results = inputs[0].reduce((prev, curr) => {return prev+curr});
  }
 //console.log('add: ', inputs, results)
  return results;
}

export const subtract = (...inputs) => {
  let results
  
  if(inputs.length > 4){
    results = inputs.slice(0, inputs.length-3).reduce((prev, curr) =>{return prev-curr});
  }
  if(inputs.length == 4){
    results = inputs[0].reduce((prev, curr) =>{return prev-curr});
  }
    //console.log('subtract: ', inputs, results)
  return results;
}

export const multiply = (...inputs) => {
  let results

  if(inputs.length > 4){
    results = inputs.slice(0, inputs.length-3).reduce((prev, curr) =>{return prev*curr});
  }
  if(inputs.length == 4){
    results = inputs[0].reduce((prev, curr) =>{return prev*curr});
  }
  //console.log('multiply: ', inputs, results)
  return results;
}

export const divide = (...inputs) => {
  let results

  if(inputs.length > 4){
    results = inputs.slice(0, inputs.length-3).reduce((prev, curr) =>{return prev/curr});
  }
  if(inputs.length == 4){
    results = inputs[0].reduce((prev, curr) =>{return prev/curr});
  }
  //console.log('divide: ', inputs, results)
  return results;
}

export const compare = (...inputs) => {
  const to_compare = inputs[0]
  const task = inputs[1]
  switch(task){
    case "<":
      return to_compare[0] < to_compare[1];
    case ">":
      return to_compare[0] > to_compare[1];
    case "<=":
      return to_compare[0] <= to_compare[1];
    case ">=":
      return to_compare[0] >= to_compare[1];
    case "==":
      return to_compare[0] == to_compare[1];
  }
}

export const round_number = (...inputs) => {
  const num = inputs[0]
  const decimals = inputs[1]
  let roundedNum = num.toFixed(decimals);
  if (decimals === 0) {
    roundedNum = parseInt(roundedNum);
  }
  return roundedNum;
}

export const floor_number = (...inputs) => {
  const num = inputs[0]
  return Math.floor(num);
}

export const ceiling_number = (...inputs) => {
  const num = inputs[0]
  return Math.floor(num)+1;
}

export const range = (...inputs) => {
  const start = inputs[0];
  const end = inputs[1];
  const step = inputs[2] ?? 1;
  const data = [];

  if (step === 0) {
    throw new Error("Step cannot be 0");
  }

  const direction = Math.sign(end - start) || 1; // 1 or -1
  const realStep = Math.abs(step) * direction;

  // Loop with floating point safety
  for (
    let x = start;
    direction > 0 ? x <= end : x >= end;
    x = Number((x + realStep).toFixed(12))
  ) {
    data.push(x);
  }

  return data;
}

let mathPromise = null;

const loadMath = () => {
  if (!mathPromise) {
    mathPromise = import('mathjs');
  }
  return mathPromise;
};

// Cache for compiled expressions (plain eval)
const compiledExpressionCache = new Map();
// Cache for derivatives: key = `${expression}::${variable}`
const derivativeCache = new Map();

/**
 * eval_equation(expression, scope?, resultFunc?)
 *
 * - If scope is non-empty: evaluates numerically using a cached compiled expression.
 * - If scope is empty: returns a simplified/pretty string (no compile needed).
 */
export const eval_equation = async (...inputs) => {
  const expression = inputs[0];
  const scope      = inputs[1] ?? {};
  const resultFunc = typeof inputs[2] === 'function' ? inputs[2] : undefined;

  if (!expression) {
    throw new Error('Expression is required');
  }

  try {
    const math = await loadMath();
    const hasScope = scope && Object.keys(scope).length > 0;

    let result;

    if (hasScope) {
      // Use compiled + cached expression for numeric evaluation
      let compiled = compiledExpressionCache.get(expression);
      if (!compiled) {
        compiled = math.compile(expression);
        compiledExpressionCache.set(expression, compiled);
      }
      result = compiled.evaluate(scope);
    } else {
      // Keep your old behavior for "pure" expressions: simplify + format
      result = math.format(math.simplify(expression));
    }

    if (resultFunc) resultFunc(result);
    return result;
  } catch (error) {
    console.error('Error evaluating expression', error);
    return null;
  }
};

/**
 * derive_equation(expression, deriveVariable, scope?, resultFunc?)
 *
 * - If scope is non-empty: evaluates the derivative numerically (using cached compiled derivative).
 * - If scope is empty: returns the symbolic derivative string (using cached node).
 */
export const derive_equation = async (...inputs) => {
  const expression     = inputs[0];
  const deriveVariable = inputs[1];
  const scope          = inputs[2] ?? {};
  const resultFunc     = typeof inputs[3] === 'function' ? inputs[3] : undefined;

  if (!expression) {
    console.error('Expression is required');
    return null;
  }

  if (!deriveVariable) {
    console.error('Variable to derive is required');
    return null;
  }

  try {
    const math = await loadMath();
    const key = `${expression}::${deriveVariable}`;

    // Get or build cached derivative (node + compiled)
    let cached = derivativeCache.get(key);
    if (!cached) {
      const node = math.derivative(expression, deriveVariable); // mathjs Node
      const compiled = node.compile();
      cached = { node, compiled };
      derivativeCache.set(key, cached);
    }

    const hasScope = scope && Object.keys(scope).length > 0;

    const result = hasScope
      ? cached.compiled.evaluate(scope) // numeric derivative
      : cached.node.toString();         // symbolic derivative

    if (resultFunc) resultFunc(result);
    return result;
  } catch (error) {
    console.error('Error deriving equation', error);
    return null;
  }
};


export const linear_interpolation = (...inputs) => {
  if (inputs.length < 8) {
    console.error('linear_interpolation requires 5 inputs');
    return null;
  }
  const x = inputs[0]
  const x0 = inputs[1]
  const x1 = inputs[2]
  const y0 = inputs[3]
  const y1 = inputs[4] 
  return y0 + (x - x0) * (y1 - y0) / (x1 - x0);
}

export const minimum = (...inputs) => {
  if (inputs.length < 4) {
    console.error('minimum requires at least 1 input');
    return null;
  }
  const values = inputs[0]
  return Math.min(...values);
}

export const maximum = (...inputs) => {
  if (inputs.length < 4) {
    console.error('maximum requires at least 1 input');
    return null;
  }
  const values = inputs[0]
  return Math.max(...values);
}

// export const formatNum = (...inputs) => {
//   let number = inputs[0]
//   let format = inputs[1]
//   // Split the format into integer and decimal parts
//   const [integerFormat, decimalFormat] = format.split(".");
//   let [integerPart, decimalPart] = number.toString().split(".");

//   // Round the number if there's a decimal format
//   if (decimalFormat) {
//     const decimalPlaces = decimalFormat.length;
//     const factor = Math.pow(10, decimalPlaces);
//     // Round the number to the specified number of decimal places
//     number = Math.round(number * factor) / factor;
//     // Update integer and decimal parts after rounding
//     [integerPart, decimalPart] = number.toString().split(".");
//   }

//   // Pad the integer part
//   integerPart = integerPart.padStart(integerFormat.length, '0');

//   if (decimalFormat) {
//     if (decimalPart) {
//       // Truncate or pad the decimal part to match the format
//       decimalPart = decimalPart.padEnd(decimalFormat.length, '0').substring(0, decimalFormat.length);
//     } else {
//       // If the number has no decimal part but the format requires it, pad with zeros
//       decimalPart = "".padEnd(decimalFormat.length, '0');
//     }
//     return `${integerPart}.${decimalPart}`;
//   } else {
//     // If there's no decimal part in the format, return the integer part
//     return integerPart;
//   }
// }

export const formatNum = (...inputs) => {
  let number = inputs[0];
  const format = inputs[1] ?? "";
  const commas = inputs[2] === true;

  let numStr = String(number);
  let sign = "";

  // sign
  if (numStr[0] === "-") {
    sign = "-";
    numStr = numStr.slice(1);
  }

  // split format
  let intMaskRaw = "";
  let decMaskRaw;
  if (format.includes(".")) {
    [intMaskRaw, decMaskRaw] = format.split(".", 2);
  } else {
    intMaskRaw = format;
    decMaskRaw = undefined;
  }
  const hadEmptyDecimalSection = decMaskRaw === "";
  if (hadEmptyDecimalSection) decMaskRaw = undefined;

  // split number into parts
  let intSrc, decSrc;
  if (numStr.includes(".")) {
    [intSrc, decSrc] = numStr.split(".", 2);
  } else {
    intSrc = numStr;
    decSrc = "";
  }

  // ---------- INTEGER ----------
  let intOut = "";
  if (intMaskRaw === "*") {
    intOut = intSrc; // full integer as-is
  } else if (intMaskRaw) {
    const pf = intMaskRaw;                 // e.g., "0__", "0_0"
    const digits = intSrc.split("");
    const offset = digits.length - pf.length; // right-align
    for (let i = 0; i < pf.length; i++) {
      const ch = pf[i];
      if (ch === "0") {
        const di = i + offset;
        const dig = di >= 0 ? digits[di] : "0"; // pad with 0
        intOut += dig;
      } else if (ch === "_") {
        // skip position
      } else if (ch === "*") {
        intOut += intSrc; // mixed '*' fallback
      }
    }
  } else {
    intOut = decMaskRaw != null ? "" : intSrc;
  }

  // ---------- DECIMALS ----------
  let decOut = "";
  let showDot;

  if (decMaskRaw == null) {
    showDot = false;
  } else if (decMaskRaw === "*") {
    // all decimals as-is
    decOut = decSrc;
    showDot = decOut.length > 0;
  } else {
    const df = decMaskRaw;

    // CASE A: mask is ONLY zeros -> round to that many places
    if (/^0+$/.test(df)) {
      const places = df.length;
      const factor = 10 ** places;
      const rounded = Math.round(Number(`${intSrc}.${decSrc || "0"}`) * factor) / factor;
      const [ri, rd = ""] = String(rounded).split(".");
      // if integer changed and left mask was '*', reflect that
      if (intMaskRaw === "*") intOut = ri;
      decOut = rd.padEnd(places, "0").substring(0, places);
      showDot = true;
    } else {
      // CASE B: mixed '_' and/or '0' (no global rounding!)
      let di = 0; // index into ORIGINAL decSrc
      for (let i = 0; i < df.length; i++) {
        const ch = df[i];
        if (ch === "_") {
          if (di < decSrc.length) di++; // skip one if available
        } else if (ch === "0") {
          const d = di < decSrc.length ? decSrc[di] : "0";
          decOut += d;
          if (di < decSrc.length) di++;
        } else if (ch === "*") {
          // append remaining as-is
          decOut += decSrc.slice(di);
          di = decSrc.length;
        }
      }

      // dot visibility: if no int mask and decimal mask starts with '_', hide dot
      if (!intMaskRaw && df[0] === "_") {
        showDot = false;
      } else {
        showDot = true;
      }
    }
  }

  // ---------- COMMAS ----------
  if (commas && intOut) {
    intOut = intOut.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // ---------- RESULT ----------
  if (!showDot) {
    return sign + intOut + decOut;
  } else {
    const prefix = intOut ? intOut + "." : ".";
    return sign + prefix + decOut;
  }
};



export const modulo = (...inputs) => {
  let input_number = 0
  let length_number = 0
  if (inputs.length >= 5){
    input_number = inputs[0]
    length_number = inputs[1]
  }else{
    console.log("modulo_error: ", 'incorrect_inputs')
    return 0
  }

  try{
    return input_number%length_number
  }catch(error){
    console.log("modulo_error: ", error)
  }
  return 0
}